import styled from 'styled-components';

const Wrapper = styled.div`
  margin: -50px -20px 20px;
`;

export default Wrapper;